import { ContextBase } from '@hpfe/common-base';

import { Config } from '@/common/context/config';
import { Permission } from '@/common/context/permission';
import { Request } from '@/common/context/request';
import { User } from '@/common/context/user';

const config = new Config();
const user = new User();
const permission = new Permission();
const request = new Request();

export const context = new (class extends ContextBase {
  config = config;
  user = user;
  permission = permission;
  request = request;

  constructor() {
    super({ config, user });

    // 延迟注入
    user.init({ config });
    permission.init({ user });
    request.init({ config, user });
  }
})();
